// extracted by mini-css-extract-plugin
export default {"unknownPage":"unknown_page_unknownPage__l8fEg","title":"unknown_page_title__5cstm","description":"unknown_page_description__BzPz2"};